// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { DirectionalIcon as BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M9.4 17.17 14.68 12 9.4 6.83l1.4-1.43 6.73 6.6-6.73 6.6-1.4-1.43ZM6.47 12" className={rtlFlipCss} />
  </BaseIcon>
)
